import { LuSparkles, LuPlayCircle } from "react-icons/lu";
import * as styled from "./FeatureBlock.styled"

function FeatureBlock({ list, title, action }) {
  return (
    <styled.Wrapper>
      <styled.Header>
        <styled.Badge>
          <LuSparkles size={14} /> Новинка
        </styled.Badge>
      </styled.Header>
      <styled.Title>{title}</styled.Title>
      <styled.List>
        {list.map(({ number, text }) => (
          <styled.Item key={number}>
            <styled.Number>{number}</styled.Number>
            <styled.Text>{text}</styled.Text>
          </styled.Item>
        ))}
      </styled.List>
      {action && (
        <styled.Action type="button" onClick={action.onClick}>
          <LuPlayCircle size={18} /> {action.label}
        </styled.Action>
      )}
    </styled.Wrapper>
  )
};

export default FeatureBlock;
